import { render, staticRenderFns } from "./ScrollSupplier.vue?vue&type=template&id=7812714a"
import script from "./ScrollSupplier.vue?vue&type=script&lang=js"
export * from "./ScrollSupplier.vue?vue&type=script&lang=js"
import style0 from "./ScrollSupplier.vue?vue&type=style&index=0&id=7812714a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports